import { render, staticRenderFns } from "./FluxosCanais.vue?vue&type=template&id=233c09ee"
import script from "./FluxosCanais.vue?vue&type=script&lang=js"
export * from "./FluxosCanais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports